import { useMutation, UseMutationOptions } from "react-query";
import { auth, firestore, getRef } from "../utils/firebase/setupFirebase";
import { v4 as uuidv4 } from "uuid";
import { generateRandomString } from "../utils/generateRandomString";
import { doc, setDoc } from "@firebase/firestore";
import { Game, GameStatus } from "../screens/GameScreen/utils/Game";

export const useCreateGameMutation = (options: UseMutationOptions) => {
  const currentUser = auth.currentUser;

  return useMutation(async () => {
    const gameId = `${uuidv4()}-${generateRandomString()}`;

    const gameRef = getRef(["games", gameId]);
    const gameData: Game = {
      masterUserId: currentUser!.uid,
      activePlayerId: null,
      status: GameStatus.WAIT_FOR_MEMBERS,
      membersMap: {
        [currentUser!.uid]: {
          userId: currentUser!.uid,
          displayName: currentUser!.displayName ?? undefined,
        },
      },
    };
    await setDoc(doc(firestore, gameRef), gameData, { merge: true });
    return gameId;
  }, options);
};
